import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import type { OrderStatus } from './hooks';

// Цвета согласованы с design-токенами (accent — turquoise, primary — deep blue):
//   accepted    — default neutral
//   in_progress — blue (deep-trust-blue)
//   ready       — cyan/turquoise (accent)
//   issued      — green (success)
//   cancelled   — red (danger)
const STATUS_COLORS: Record<OrderStatus, string> = {
  accepted: 'default',
  in_progress: 'blue',
  ready: 'cyan',
  issued: 'green',
  cancelled: 'red',
};

interface OrderStatusTagProps {
  status: OrderStatus;
}

export function OrderStatusTag({ status }: OrderStatusTagProps): JSX.Element {
  const { t } = useTranslation();
  return <Tag color={STATUS_COLORS[status]}>{t(`orders.status.${status}`)}</Tag>;
}
